export const REQUEST_ACCESS_EXPERIMENT_FLAG_V3 =
  'apollo.web.request-access-when-blocked-v3';

export enum AUTO_INVITE_MESSAGES {
  SUCCESS = 'You successfully added a member to the board',
  ERR0R = 'Error Occured',
}

// AUTO INVITE MEMBER SUCCESS FLOW

const SUCCESS_CONTENT_TITLE = 'Adding them now';
const SUCCESS__CONTENT_TEXT =
  "You'll soon be collaborating together on this board.";
const SUCCESS_BUTTON_TEXT = 'Go to board';
const DESCRIPTION = "We're adding:";

// WORKSPACE RESTRICTED CONTENT MODAL

const WORKSPACE_DIALOG_TITLE = 'Add to Workspace first';
const WORKSPACE_AVATAR_DESCRIPTION = (workspaceName: string): string =>
  `Add to ${workspaceName} Workspace`;
const WORKSPACE_DIALOG_DESCRIPTION =
  'Once added, they can join all visible boards and create new boards. You’ll be automatically billed for them too.';
const WORKSPACE_DIALOG_CANCEL_BUTTON = 'Cancel';
const WORKSPACE_DIALOG_ADD_BUTTON = 'Add to Workspace';

// INVITE ERROR CONTENT MODAL

const INVITE_ERROR_CONTENT_TITLE = 'Contact your admin';
const INVITE_ERROR_CONTENT_TEXT =
  "We're having trouble adding your teammate. Contact your Workspace or Enterprise admin for help.";
const INVITE_ERROR_BUTTON_TEXT = 'OK, got it';

// ERROR CONTENT MODAL

const ERROR_CONTENT_TITLE = 'Something went wrong';
const ERROR_CONTENT_TEXT =
  "We're having trouble adding your teammate. Ga back to the request access email, and select Add to board to try again.";

export const constants = {
  AUTO_INVITE_MESSAGES,
  REQUEST_ACCESS_EXPERIMENT_FLAG_V3,
  SUCCESS_CONTENT_TITLE,
  SUCCESS__CONTENT_TEXT,
  SUCCESS_BUTTON_TEXT,
  DESCRIPTION,
  WORKSPACE_DIALOG_TITLE,
  WORKSPACE_AVATAR_DESCRIPTION,
  WORKSPACE_DIALOG_DESCRIPTION,
  WORKSPACE_DIALOG_CANCEL_BUTTON,
  WORKSPACE_DIALOG_ADD_BUTTON,
  INVITE_ERROR_CONTENT_TEXT,
  INVITE_ERROR_CONTENT_TITLE,
  INVITE_ERROR_BUTTON_TEXT,
  ERROR_CONTENT_TITLE,
  ERROR_CONTENT_TEXT,
};
